<template>
	<div class="objectNest">
		<!--pre>
			{{ $route.params}}
			{{ ApiData }}
		</pre-->
		<div v-if="$route.params.object_type == 'complex'">
			<ssoModuleFilter @change="OnFilterApply" :complex_corp_options="complex_corp_options"/>
			<ReClientNeeds />
			<ReSearchObjBig :objData="ApiData[0]" :objFlatsData="objFlatsData" :objFlatsPrintData="objFlatsPrintData" v-model="dSearchType" :bIsLoading="bIsLoading" @change="OnFilterApply()"/>
		</div>
		<div v-if="$route.params.object_type == 'flat'">
			<ReSearchFlatBig :objData="ApiData[0]" />
		</div>
		<div v-if="$route.params.object_type == 'second'">
			<ObjectScndNest />
		</div>
	</div>
</template>
<script>
import ReSearchObjBig from 'src/our_components/ReSearchObjBig.vue'; 
import ReSearchFlatBig from 'src/our_components/ReSearchFlatBig.vue'; 
import ssoModuleFilter from 'src/our_modules/SearchSendObjects/sso_module_filter.vue';
import ReClientNeeds from 'src/our_modules/SearchSendObjects/ReClientNeeds.vue';
import ObjectScndNest from 'src/our_modules/SearchSendObjects/ObjectScndNest.vue';

export default {
	name: 'objectnest-page',
	components: {
		ReSearchObjBig,
		ReSearchFlatBig,
		ssoModuleFilter,
		ReClientNeeds,
		ObjectScndNest,
	},
	data() {
		return {
			ApiData: {},
			objFlatsData: {},
			objFlatsPrintData: {},
			objGetParams: {},
			dSearchType: 'flat_list',
			bIsLoading: false,
			complex_corp_options: [],
		};
	},
	watch: {
		'$route' (to, from) {
			if(this.$route.params.object_type == 'complex'){
				if(typeof this.ApiData[0] != 'undefined'){
					this.getApiFlatsData();
				}
			}
		}
	},
	methods: {
		OnFilterApply(strItogGetParams){ // применяет параметры из фильтра и запускает запрос к АПИ
			let objItogGetParams = {};
			//console.log(strItogGetParams);
			if(strItogGetParams == undefined){
				objItogGetParams = this.$GVO.GetAllGet();
			}else{
				let objGetDmp = this.$GVO.GetAllGet();
				objItogGetParams = this.$GVO.parseQueryString(strItogGetParams);
				objItogGetParams.task_id = objGetDmp.task_id;
				objItogGetParams.taskend_id = objGetDmp.taskend_id;
				objItogGetParams.client_id = objGetDmp.client_id;
			}
			if(this.dSearchType != objItogGetParams.dSearchType)objItogGetParams.dSearchType=this.dSearchType;
			strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			//console.log('OnFilterApply',location.pathname+'?'+strItogGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			if(typeof this.ApiData[0] != 'undefined'){
				//this.getApiFlatsData();
			}
		},
		getApiFlatsData(){
			let strApiMethod = 'GET';
			let filter = {};
			this.bIsLoading = true;
			this.objGetParams = this.$GVO.GetAllGet();
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				if(typeof this.objGetParams.dSearchType !='undefined') this.dSearchType = this.objGetParams.dSearchType;
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
			}
			//filter.dgk = this.$route.params.object_id;
			filter.dgk = this.ApiData[0].gk_name_tr;
			filter.ddev = this.ApiData[0].dev_name_tr;
			filter.reLimit = 10000;

			if(filter.dSearchType=='flat_list') strApiMethod = 'GET_FLAT_LIST';
			if(filter.dSearchType=='chess') strApiMethod = 'GET_FLAT_CHESS';
			//console.log(strApiMethod);
			this.$GVO.ApiCall(strApiMethod,{obj:'NovoObj',flt:{...filter,...{complexpage:1}}})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success === true){

					let objDmp = {};
					for (const key in objApi.data) {
						if (objApi.data.hasOwnProperty(key)) {
							//console.log(Object.keys(objApi.data[key]).sort());
							objDmp[key] = {};
							Object.keys(objApi.data[key]).sort().forEach(function (k_kkv) { objDmp[key][k_kkv] = objApi.data[key][k_kkv]; });
						}
					}
					//console.log(objDmp);
					
					this.objFlatsData = objDmp;
					this.objFlatsPrintData = objApi.print_data;
				}else{
					this.objFlatsData = {};
					this.objFlatsPrintData = {};
				}
				this.bIsLoading = false;
			}).catch(errorObjApi => {this.objFlatsData = {}; this.objFlatsPrintData = {}; this.bIsLoading = false; console.error(errorObjApi);});
			
		},
		getApiData(){
			if(this.$route.params.object_type == 'complex' && typeof this.$route.params.object_id != 'undefined' && this.$route.params.object_id != ''){
				this.$GVO.ApiCall('GET_COMPLEX',{obj:'NovoObj',flt:{gk_name_tr:this.$route.params.object_id,add_files:1}})
				.then((objApi) => {
					if(objApi.success === true){
						this.ApiData = objApi.data;
						this.complex_corp_options=[];
						if(typeof this.ApiData[0].b_corps_name != 'undefined' && this.ApiData[0].b_corps_name != ''){
							const corp_list = this.$GVO.SafeParseJson(this.ApiData[0].b_corps_name);
							for (const key in corp_list) {
								if (corp_list.hasOwnProperty(key)) {
									this.complex_corp_options.push({value:key,label:corp_list[key]});
								}
							}
						}
						this.getApiFlatsData();
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			} else if(this.$route.params.object_type == 'flat' && typeof this.$route.params.object_id != 'undefined' && this.$route.params.object_id != ''){
				this.objGetParams = this.$GVO.GetAllGet();
				this.$GVO.ApiCall('GET_FLAT',{obj:'NovoObj',flt:{app_id:this.$route.params.object_id,client_id:this.objGetParams.client_id,task_id:this.objGetParams.task_id,taskend_id:this.objGetParams.taskend_id}})
				.then((objApi) => {
					if(objApi.success === true){
						this.ApiData = objApi.data;
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			}
		},
	},
	mounted() {
		this.getApiData();
	}
};
</script>
<style scoped>

.oneline {
	border: 1px solid #9e77f3;
	padding: 10px 15px;
	border-radius: 0.2857rem;
	box-shadow: 0 1px 15px 0 rgba(158, 119, 243, 0.08);
	flex-direction: column;
}
@media (max-width: 768px) {
	.oneline {
		flex-wrap: wrap;
	}
}

</style>
